(function () {
  'use strict';
  const cutSelector = 'select[name="Base Cut Service"]';
  const sizeSelector = 'input[name="Custom Base Size"]';
  const actionSelector = 'button[type="submit"], input[type="submit"], .m-add-to-cart, .shopify-payment-button, shopify-accelerated-checkout';
  function fields() {
    const cut = Array.from(document.querySelectorAll(cutSelector)).find(el => !el.disabled);
    const size = Array.from(document.querySelectorAll(sizeSelector)).find(el => !el.disabled);
    return { cut, size, needsSize: !!cut && cut.value === 'Base cut to size' };
  }
  function sync() {
    const {size, needsSize} = fields();
    const product=document.querySelector('product-info');
    if(product)product.setAttribute('data-rehair-cut-invalid',String(needsSize && (!size || !size.value.trim())));
    if (!size) return;
    size.required = needsSize;
    size.placeholder = 'e.g. 7 x 9 inches';
    size.setCustomValidity(needsSize && !size.value.trim() ? 'Enter your finished base width and length before adding the cutting service.' : '');
    const id = 'rehair-cut-size-help';
    if (!document.getElementById(id)) {
      const p = document.createElement('p'); p.id = id;
      p.textContent = 'Required for base cutting: enter the finished width and length, including inches or cm.';
      size.parentElement.appendChild(p);
    }
    const ids = new Set((size.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
    ids.add(id); size.setAttribute('aria-describedby', Array.from(ids).join(' '));
  }
  function validate(event) {
    const product = document.querySelector('product-info');
    if (!event.target.closest) return;
    const cartSave = event.target.closest('.avis-popupFooter-submit');
    const action = event.type === 'submit' ? event.target : event.target.closest(actionSelector);
    if (!cartSave && (!product || !action || !product.contains(action))) return;
    sync();
    const {size, needsSize} = fields();
    const busy = !cartSave && product?.getAttribute('data-rehair-variant-pending') === 'true';
    if (!busy && (!needsSize || (size && size.value.trim()))) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (busy) return;
    if (size) {
      // Reveal the existing service disclosure; do not replace app-owned DOM.
      const disclosure = size.closest('details'); if (disclosure) disclosure.open = true;
      size.scrollIntoView({block:'center',behavior:'smooth'}); size.focus(); size.reportValidity();
    }
  }
  window.addEventListener('click', validate, true);
  window.addEventListener('submit', validate, true);
  document.addEventListener('change', event => {
    if (event.target.matches(cutSelector + ',' + sizeSelector)) sync();
  });
  document.addEventListener('input', event => { if (event.target.matches(sizeSelector)) sync(); });
  new MutationObserver(sync).observe(document.documentElement, {childList:true,subtree:true});
  sync();
})();
